import { CheckCircle2, Phone, MessageCircle } from "lucide-react";
import "../components/StartPage.css";
import "./ResultsPage.css";

const LOGO_MARK_URL = "/brand/logo-mark.png";

export default function ResultsPage({ name, date, results, assessmentDisplayName }) {
  return (
    <div className="sp-page" data-testid="results-page">
      <main className="sp-main">
        <div className="sp-card rp-card">
          {/* LEFT PANEL */}
          <section className="sp-welcome rp-welcome" aria-label="Assessment complete">
            <img
              src={LOGO_MARK_URL}
              alt=""
              aria-hidden="true"
              className="sp-watermark"
            />
            <div className="sp-welcome-top">
              <p className="sp-kicker">Assessment portal</p>
              <h1 className="sp-heading">All done</h1>
              <div className="sp-coral-rule" />

              <p className="rp-lead">
                Your responses have been submitted securely to your psychologist at Clinical Minds.
              </p>

              <ol className="sp-steps" aria-label="What happened">
                <li className="rp-step-done">
                  <span className="sp-dot rp-dot-done">
                    <CheckCircle2 size={16} strokeWidth={2.5} />
                  </span>
                  <span className="sp-step-label">
                    <b>Your details</b>
                    <span>Completed</span>
                  </span>
                </li>
                <li className="rp-step-done">
                  <span className="sp-dot rp-dot-done">
                    <CheckCircle2 size={16} strokeWidth={2.5} />
                  </span>
                  <span className="sp-step-label">
                    <b>The questions</b>
                    <span>Completed</span>
                  </span>
                </li>
                <li className="rp-step-done">
                  <span className="sp-dot rp-dot-done">
                    <CheckCircle2 size={16} strokeWidth={2.5} />
                  </span>
                  <span className="sp-step-label">
                    <b>Sent to your psychologist</b>
                    <span>Delivered securely</span>
                  </span>
                </li>
              </ol>

              <p className="sp-assist">
                <Phone size={15} strokeWidth={2} color="#506080" />
                <span>
                  Questions about your results? Call or text{" "}
                  <a href="tel:0415220944">0415 220 944</a>.
                </span>
              </p>
            </div>
          </section>

          {/* RIGHT PANEL */}
          <section className="sp-form-panel rp-confirmation" aria-label="Submission confirmed" data-testid="results-card">
            <div className="rp-success-icon">
              <CheckCircle2 size={56} strokeWidth={1.5} />
            </div>
            <h2 className="sp-form-heading">Thank you, {name}</h2>
            <p className="sp-form-sub rp-sub">
              Your assessment has been submitted successfully. There is nothing more you need to do.
            </p>

            <div className="rp-details">
              <div className="rp-detail-row">
                <span className="rp-detail-label">Assessment</span>
                <span className="rp-detail-value">{assessmentDisplayName || results?.assessment_type || 'Assessment'}</span>
              </div>
              <div className="rp-detail-row">
                <span className="rp-detail-label">Date</span>
                <span className="rp-detail-value">{date}</span>
              </div>
              <div className="rp-detail-row">
                <span className="rp-detail-label">Status</span>
                <span className="rp-detail-value rp-status">Delivered securely</span>
              </div>
            </div>

            <p className="rp-note">
              The assessment you completed has been sent directly to your psychologist. They will review your responses and discuss them with you at your next appointment.
            </p>

            <p className="sp-privacy rp-privacy">
              Your answers are private. They are stored securely and accessible only to your psychologist at Clinical Minds.
            </p>
          </section>
        </div>
      </main>

      <footer className="sp-footer">
        <span>© 2026 Clinical Minds Psychology</span>
        <span className="sp-footer-sep">·</span>
        <a href="https://www.clinicalminds.net/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <span className="sp-footer-sep">·</span>
        <a href="https://www.clinicalminds.net/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
      </footer>
    </div>
  );
}
